import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://bcwkadtsusqqhbnspbzt.supabase.co";
const supabaseAnonKey = "sb_publishable_B1UnDRKUMWhWSsaMt_PuwQ_nRwZiE_t";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
